import { systemApi } from "@/betby/api/services";
import LogUtil from "@/betby/utils/LogUtil";
import { getAppConfig } from "@/betby/infrastructure/config/appConfig";

let cachedRendererSrc: string | null = null;
let rendererSrcPromise: Promise<string> | null = null;

export function getCachedBetbyRendererScriptSrc(): string | null {
  return cachedRendererSrc;
}

export function resetBetbyRendererScriptSrcCache(): void {
  cachedRendererSrc = null;
  rendererSrcPromise = null;
}

export async function resolveBetbyRendererScriptSrc(): Promise<string> {
  if (cachedRendererSrc) {
    return cachedRendererSrc;
  }

  if (!rendererSrcPromise) {
    rendererSrcPromise = (async () => {
      const { rendererScriptUrl, rendererScriptUrlUS } = getAppConfig().betby;
      try {
        const res = await systemApi.getClientIp({
          skipErrorHandler: true,
        });

        const countryCode = res.data?.country_code;

        LogUtil.info("[BetbyScriptResolver] country_code:", countryCode);
        LogUtil.info("[BetbyScriptResolver] default_src:", rendererScriptUrl);
        LogUtil.info("[BetbyScriptResolver] us_src:", rendererScriptUrlUS);

        cachedRendererSrc =
          countryCode === "US" ? rendererScriptUrlUS : rendererScriptUrl;
        return cachedRendererSrc;
      } catch (error) {
        LogUtil.error(
          "[BetbyScriptResolver] getClientIp failed, fallback default script",
          error,
        );
        cachedRendererSrc = rendererScriptUrl;
        return cachedRendererSrc;
      }
    })();
  }

  return rendererSrcPromise;
}
